import FocusManagement from './FocusManagement.js';

function init() {
  const searchLink = document.querySelector('.headerNav__searchLink'); 
  searchLink && searchLink.addEventListener('click', openSearch);
  
  const searchOverlay = document.querySelector('.searchOverlay__close')
  searchOverlay && searchOverlay.addEventListener('click', closeSearch);
}

function openSearch() {
  const searchInput = document.getElementById('searchOverlay__search');
  const overlay = document.getElementById('searchOverlay');

  document.body.classList.add('searchOverlayOpen');
  FocusManagement.enableFocusTrap(overlay, searchInput);
  FocusManagement.onEsc(closeSearch);
}

function closeSearch() {
  console.log('CLOSE');
  const searchInput = document.getElementById('searchOverlay__search');
  const overlay = document.getElementById('searchOverlay');
  
  document.body.classList.remove('searchOverlayOpen');
  FocusManagement.disableFocusTrap(overlay);
  FocusManagement.offEsc(closeSearch);
}

const searchOverlay = {
  init
};

export default searchOverlay;